import {
  ManagerAccount,
  ManagerAccountMe,
} from '@/domain/models/AuthEnterprise';
import { DASHBOARD_API_ORIGIN, TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

export interface ManagerAccountCreateForm {
  email: string;
  name: string;
  role_type: string;
  auth_store_names: string[];
}

interface Interface {
  accountList: () => Promise<ManagerAccount[]>;
  me: () => Promise<ManagerAccountMe>;
  create: (body: ManagerAccountCreateForm) => Promise<void>;
}

export class AuthEnterpriseService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async accountList(): Promise<ManagerAccount[]> {
    return await this.restClient.get<ManagerAccount[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-enterprises` as const
    );
  }

  public async me(): Promise<ManagerAccountMe> {
    return await this.restClient.get<ManagerAccountMe>(
      `${DASHBOARD_API_ORIGIN}/api/auth-enterprise/me` as const
    );
  }

  public async create(body: ManagerAccountCreateForm): Promise<void> {
    return await this.restClient.post<ManagerAccountCreateForm, void>(
      `${DASHBOARD_API_ORIGIN}/api/auth-enterprise/create` as const,
      body
    );
  }
}
